import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { push } from '../actions/HistoryActions';
import { getCategories } from '../actions/edit/CategoryActions';
import { getAuthors } from '../actions/manage/AuthorActions';
import ArticleListingPage from '../content-listing/components/ArticleListingPage';
import { selectIncludePrimaryLanguageInSlug, selectPrimaryLanguage } from '../knowledge-base/selectors/knowledgeBaseDetails';
import { isFetched } from '../utils/ajaxUtils';
import { useAppSelector } from '../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ManageV3() {
  const dispatch = useDispatch();
  const {
    articlesInfo,
    knowledgeBaseDetails,
    knowledgeScopes
  } = useAppSelector(state => ({
    articlesInfo: state.articlesInfo,
    knowledgeBaseDetails: state.knowledgeBaseDetails,
    knowledgeScopes: state.knowledgeScopes
  }));
  const includePrimaryLanguageInSlug = useAppSelector(selectIncludePrimaryLanguageInSlug);
  const primaryLanguage = useAppSelector(selectPrimaryLanguage);
  const isKBFetched = isFetched(knowledgeBaseDetails);
  useEffect(() => {
    if (isKBFetched && knowledgeBaseDetails.knowledgeBase.id) {
      dispatch(getAuthors(knowledgeBaseDetails.knowledgeBase.id));
    }
  }, [knowledgeBaseDetails.knowledgeBase.id, dispatch, isKBFetched]);
  useEffect(() => {
    if (isKBFetched && knowledgeBaseDetails.knowledgeBase.id) {
      dispatch(getCategories(knowledgeBaseDetails.knowledgeBase.language, knowledgeBaseDetails.knowledgeBase.id));
    }
  }, [knowledgeBaseDetails.knowledgeBase.id, knowledgeBaseDetails.knowledgeBase.language, dispatch, isKBFetched]);
  const onRouteChange = route => dispatch(push(route));
  return /*#__PURE__*/_jsx(ArticleListingPage, {
    articlesInfo: articlesInfo,
    includePrimaryLanguageInSlug: includePrimaryLanguageInSlug,
    knowledgeBaseDetails: knowledgeBaseDetails,
    knowledgeScopes: knowledgeScopes,
    onRouteChange: onRouteChange,
    primaryLanguage: primaryLanguage
  });
}